import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  /**
   * Można za jego pomocą, w połączeniu z textResource pipe'em, załadować plik HTML (np. w przypadku, kiedy potrzebujemy
   * użycia HTML'owych znaczników - stylizacji tekstu, list, etc.).
   * Aby pipe zadziałał poprawnie, należy go zbindować do property elementu rodzica, np. do [innerHtml]. Nie mylić z
   * [innerHTML]! Więcej informacji na wiki projektu na GitLabie
   *
   * @param html string z zawartością pliku HTML do załadowania
   * @param args
   */
  transform(html: string | null, ...args: unknown[]): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html || '');
  }
}
